<template>
  <modal
    id="login-modal"
    @close="closeModal"
    :show.sync="showLoginModal"
    size="sm"
  >
    <div class="text-center mb-3 logo-header" v-if="!isLoggedIn">
      <div>
        <img class="logo" src="/img/brand/artgrab-logo.png" alt="Art Grab" />
        Please log in or create an account.
      </div>
      <button
        type="button"
        @click="closeModal"
        data-dismiss="modal"
        aria-label="Close"
        class="close"
      >
        <span>×</span>
      </button>
    </div>
    <div v-if="!isLoggedIn" class="login-toggle text-center">
      <base-radio
        @input="handleChangeLogin"
        name="login"
        v-model="radio.login"
        class="font-weight-bold"
        >LOG IN</base-radio
      >
      <base-radio
        @input="handleChangeLogin"
        name="create-account"
        v-model="radio.login"
        class="font-weight-bold"
        >CREATE ACCOUNT</base-radio
      >
    </div>

    <!-- LOGIN -->
    <div v-if="!isLoggedIn && radio.login === 'login'" class="login-wrapper">
      <form
        role="form"
        @submit.prevent="handleLoginSubmit"
        aria-label="Login form"
      >
        <base-input
          label="Email"
          class="mb-3"
          type="email"
          placeholder="Enter your email address"
          v-model="loginForm.email"
          spellcheck="false"
        ></base-input>

        <base-input
          label="Password"
          class="mb-3"
          type="password"
          placeholder="Enter your password"
          v-model="loginForm.password"
          required
        ></base-input>

        <div id="login-errors" class="login-errors" role="alert">
          {{ loginError }}
        </div>

        <div class="text-center">
          <base-button
            type="primary"
            :loading="loginLoading"
            nativeType="input"
            block
            class="mt-4 mb-2"
            >LOG IN</base-button
          >
        </div>
      </form>
    </div>

    <!-- CREATE ACCOUNT -->
    <div
      v-if="!isLoggedIn && radio.login === 'create-account'"
      class="create-account-wrapper"
    >
      <form
        role="form"
        @submit.prevent="handleCreateAccountSubmit"
        aria-label="Create Account"
      >
        <base-input
          label="Email"
          class="mb-3"
          type="email"
          placeholder="Enter your email address"
          v-model="createAccount.email"
          spellcheck="false"
          required
        ></base-input>

        <base-input
          label="Password"
          class="mb-3"
          type="password"
          placeholder="Enter your password"
          v-model="createAccount.password"
          required
        ></base-input>

        <base-input
          label="Confirm Password"
          class="mb-3"
          type="password"
          placeholder="Re-enter your password"
          v-model="createAccount.repassword"
          required
        ></base-input>

        <div class="text-center">
          <base-checkbox class="mb-3" v-model="termsCheckbox">
            I accept the&nbsp;
            <router-link to="/terms" target="_blank"
              >Art Grab Terms of Use</router-link
            >.
          </base-checkbox>
        </div>

        <div class="create-account-errors" role="alert">
          {{ createFormError || createAccountError }}
        </div>

        <div class="text-center">
          <base-button
            type="primary"
            :loading="createAccountLoading"
            nativeType="input"
            block
            class="mt-4 mb-2"
            >CREATE ACCOUNT</base-button
          >
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import { mapState } from "vuex";
const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "login-modal",
  data() {
    return {
      selected: null,
      loading: false,
      loginForm: {
        email: "",
        password: "",
      },
      createAccount: {
        email: "",
        password: "",
        repassword: "",
      },
      termsCheckbox: false,
      createFormError: "",
      createAccountLoading: false,
      radio: {
        login: "login",
      },
      loginLoading: false,
    };
  },
  computed: {
    ...mapState([
      "user",
      "isLoggedIn",
      "loginError",
      "createAccountError",
      "showLoginModal",
    ]),
  },
  methods: {
    handleChangeLogin: function (plan) {
      this.radio.login = plan;
    },
    handleLoginSubmit() {
      this.loginLoading = true;
      const {
        loginForm: { email, password },
      } = this;
      this.$store.dispatch("loginRequest", { email, password }).then(() => {
        if (this.isLoggedIn) {
          this.$store.commit("loginError", "");
          this.loginForm.email = "";
          this.loginForm.password = "";
          this.$store.commit("showLoginModal", false);
          this.$store.dispatch("getCart");
        }
        this.loginLoading = false;
      });
    },
    handleCreateAccountSubmit() {
      this.createAccountLoading = true;
      const {
        createAccount: { email, password, repassword },
        termsCheckbox,
      } = this;

      if (email.length >= 5) {
        if (password.length >= 8) {
          if (password == repassword) {
            if (termsCheckbox) {
              this.createFormError = "";

              this.$store
                .dispatch("createAccount", { email, password })
                .then(() => {
                  if (this.isLoggedIn) {
                    this.$store.commit("createAccountError", "");
                    this.createFormError = "";
                    this.createAccount.email = "";
                    this.createAccount.password = "";
                    this.createAccount.repassword = "";
                    this.termsCheckbox = false;
                    this.createAccountLoading = false;
                    this.$store.commit("showLoginModal", false);
                  } else {
                    this.createFormError =
                      "There was an error creating your account. Please try again or contact us.";
                  }
                });
            } else {
              this.createFormError =
                "Please accept the terms by checking the checkbox.";
              this.createAccountLoading = false;
            }
          } else {
            this.createFormError =
              "Password and confirm password do not match.";
            this.createAccountLoading = false;
          }
        } else {
          this.createFormError =
            "Password length needs to be at least 8 characters.";
          this.createAccountLoading = false;
        }
      } else {
        this.createFormError = "Please enter a valid email address.";
        this.createAccountLoading = false;
      }
    },
    closeModal() {
      this.$store.commit("createAccountError", "");
      this.createFormError = "";
      this.createAccount.email = "";
      this.createAccount.password = "";
      this.createAccount.repassword = "";
      this.termsCheckbox = false;
      this.createAccountLoading = false;
      this.$store.commit("showLoginModal", false);
      this.$store.commit("loginError", "");
      this.loginForm.email = "";
      this.loginForm.password = "";
      this.radio.login = "login";
    },
  },
};
</script>

<style lang="scss">
#login-modal {
  .error-message,
  .create-account-errors,
  .login-errors {
    color: red;
    font-size: 0.875rem;
    text-align: center;
    margin-top: 0.75rem;
  }

  .logo-header {
    .logo {
      margin: 40px auto 10px;
      width: 180px;
      display: block;
    }
    .close {
      position: absolute;
      top: 20px;
      right: 20px;
      padding: 1.25rem;
      margin: -1rem -1rem -1rem auto;
    }
  }

  .login-toggle {
    padding: 0.5rem;
    background-color: #f7f7f7;
    border-radius: 3px;
    display: flex;
    justify-content: space-around;
    margin-bottom: 1rem;
  }

  .helper-text {
    font-size: 0.7rem;
    line-height: 1.7;
    display: block;
  }
}
</style>
